module.exports = __webpack_public_path__ + "aabfc60d081241bc831f2630c9df776b.svg";